/* eslint-env browser, jquery */
import React from 'react';
import axios from 'axios';
import quiz from '../content/quiz.json';

const DEBUG = (process.env.NODE_ENV || '').toLowerCase() !== 'production';
const state = { answers: {}, scores: {} };
const POST_URL = DEBUG
  ? 'http://localhost:3002/gc-leads/'
  : 'https://dwh-tracking.it.auth0.com/gc-leads/';

export default function clientRouter(
  WrappedComponent,
  initialRoute = '/',
  pageEvents = null,
  page
) {
  return class PageReactRouter extends React.Component {
    constructor(props) {
      super(props);
      this.handleRouteChange = this.handleRouteChange.bind(this);
      this.changeFormState = this.changeFormState.bind(this);
      pageEvents.listener = route => this.handleRouteChange(route);
      this.state = {
        route: initialRoute,
        formState: 'not-submitted'
      };
    }

    componentDidMount() {
      state.answers = {};
      state.scores = {};
    }

    componentDidUpdate() {
      setTimeout(() => $('html,body').animate({ scrollTop: 0 }, 0), 100);
    }

    componentWillUnmount() {
      pageEvents.listener = null;
    }

    handleRouteChange(route) {
      this.setState({
        route
      });
    }

    changeFormState(formState) {
      this.setState({
        formState
      });
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          route={this.state.route}
          goToRoute={route => goToRoute(route)}
          onAnswerClicked={(key, answer, score, nextKey) =>
            onAnswerClicked(key, answer, score, nextKey)}
          getScore={() => getScore()}
          onFormSubmit={form => onFormSubmit(form, route => goToRoute(route))}
        />
      );
    }
  };

  function goToRoute(route) {
    page(`/gdpr-assessment${route}`);
  }
}

function onAnswerClicked(key, answer, score, nextKey) {
  state.answers[key] = answer;
  state.scores[key] = score;

  const nextQuestion = $(`#${nextKey}`);
  if (nextQuestion.length) {
    $('html,body').animate({ scrollTop: nextQuestion.offset().top - 50 }, 'slow');
  }
}

function getScore() {
  const maxScore = getMaxScore();
  const score = Object.keys(state.scores)
    .map(key => state.scores[key])
    .reduce((accumulator, current) => accumulator + current, 0);

  return Math.round(score / maxScore * 100);
}

function getMaxScore() {
  return quiz
    .map(question => Math.max(...question.answers.map(answer => answer.value)))
    .reduce((accumulator, current) => accumulator + current, 0);
}

function onFormSubmit(form, goToRoute) {
  form.gdprAssessmentDownloadKey = encodeURIComponent(
    btoa(
      Object.keys(state.answers)
        .map(key => `${key.replace('answer-', '')},${state.answers[key]}`)
        .join(';')
    )
  );
  goToRoute('/results');
  sendLead(form);
  console.log(form.gdprAssessmentDownloadKey);
}

function sendLead({
  firstName,
  lastName,
  email,
  phone,
  company,
  role,
  consent,
  gdprAssessmentDownloadKey
}) {
  const data = {
    name: `${firstName} ${lastName}`,
    firstName,
    lastName,
    email,
    role,
    phone,
    company,
    contentUrl: 'auth0.com/gdpr-assessment/',
    contentId: 'gdpr-assessment',
    consent: consent === 'true',
    gdprAssessmentDownloadUrl: `auth0.com/gdpr-assessment/report.pdf?k=${gdprAssessmentDownloadKey}`
  };
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  return axios.post(POST_URL, data, config);
}



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/utils/clientRouter.js